export default function areRoutesEqual(a, b) {
  return a === b || !!(a && b) && a.key === b.key && a.value === b.value;
}